import { AddEdit } from '../../../../../interfaces/user.interface';
import { Validation } from '../../../../../interfaces/common';
import {
  VALIDATION_FIELD_MAPPING,
  APP_ERROR_MESSAGES,
  Regex,
} from '../../../../../utils/appConstant';

export const validateAddEditForm = (formData: AddEdit, fieldToValidate?: string, isEdit?: boolean) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.salutation) {
    if (!formData.salutation) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.salutation,
        message: APP_ERROR_MESSAGES.users.addEdit.blankSalutation,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.firstName) {
    if (!formData.firstName.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.firstName,
        message: APP_ERROR_MESSAGES.users.addEdit.blankFirstName,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.lastName) {
    if (!formData.lastName.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.lastName,
        message: APP_ERROR_MESSAGES.users.addEdit.blankLastName,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.email) {
    if (!formData.email?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.users.addEdit.blankEmail,
      });
    } else if (!Regex.email.test(formData.email.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.users.addEdit.invalidEmail,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.contactNumber) {
    if (!formData.contactNumber.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.contactNumber,
        message: APP_ERROR_MESSAGES.users.addEdit.blankPhoneNumber,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.role) {
    if (!formData.role) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.role,
        message: APP_ERROR_MESSAGES.users.addEdit.blankRole,
      });
    }
  }

  if (!isEdit && (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.password)) {
    if (!formData.password) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.password,
        message: APP_ERROR_MESSAGES.users.addEdit.blankPassword,
      });
    } else if (!Regex.password.test(formData.password)) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.password,
        message: APP_ERROR_MESSAGES.users.addEdit.invalidPassword,
      });
    }
  }

  return validations;
};
